export const data = [
  {
    name: "Mert Günok",
    position: "Kaleci",
    jersey_number: 34,
    img: "https://images.bjk.com.tr/images/players/mert-gunok_229x270_000003.png",
    statistics:
      "1 Mart 1989 tarihinde Karabük’te dünyaya geldi. 196 cm boyundaki milli file bekçisi; Fenerbahçe, Bursaspor ve M. Başakşehir kulüplerinde forma giydi. Mert Günok, 2021-22 sezonu başında Beşiktaşımız ile sözleşme imzaladı.",
  },
  {
    name: "Ersin Destanoğlu",
    position: "Kaleci",
    jersey_number: 30,
    img: "https://images.bjk.com.tr/images/players/ersin-destanoglu-2-2_229x270_000004.png",
    statistics:
      "1 Ocak 2001 tarihinde dünyaya geldi. Özkaynak Düzenimizden yetişen 195 cm boyundaki genç kaleci, 2017-18 sezonunda A Takım kadromuza yükseldi.",
  },
  {
    name: "Arthur Masuaku",
    position: "Defans",
    jersey_number: 26,
    img: "https://images.bjk.com.tr/images/players/arthur-masuaku_229x270_000002.png",
    statistics:
      "7 Kasım 1993 tarihinde Fransa’da dünyaya geldi. 179 cm boyundaki defans oyuncusu; Valenciennes, Olympiakos ve West Ham United kulüplerinde forma giydi. Demokratik Kongo Cumhuriyeti A Milli Takımı formasıyla yedi maçta bir gol kaydeden Arthur Masuaku, 2022-23 sezonu başında Beşiktaşımız ile sözleşme imzaladı",
  },
  {
    name: "Tayyip Talha Sonuç",
    position: "Defans",
    jersey_number: 5,
    img: "https://images.bjk.com.tr/images/players/tayyip-talha-sanuc_229x270_000001.png",
    statistics:
      "17 Aralık 1999 tarihinde dünyaya geldi. 188 cm boyundaki defans oyuncusu; Kardemir Karabükspor ve Adana Demirspor kulüplerinde forma giydi. Tayyip Talha Sanuç, 2022-23 sezonu başında Beşiktaşımızla sözleşme imzaladı.",
  },
  {
    name: "Jonas Svensson",
    position: "Defans",
    jersey_number: 2,
    img: "https://images.bjk.com.tr/images/players/jonas-svensson_229x270_000004.png",
    statistics:
      "6 Mart 1993 tarihinde Norveç’te doğdu. 170 cm boyundaki defans oyuncusu; Rosenborg, AZ Alkmaar ve Adana Demirspor kulüplerinde forma giydi. Jonas Svensson, 2023-24 sezonu devre arasında Kulübümüzle sözleşme imzaladı.",
  },
  {
    name: "Gabriel Paulista",
    position: "Defans",
    jersey_number: 3,
    img: "https://images.bjk.com.tr/images/players/gabriel-paulista_229x270.png",
    statistics:
      "26 Kasım 1990 tarihinde Brezilya’da dünyaya geldi. 185 cm boyundaki defans oyuncusu; Villarreal, Arsenal, Valencia ve Atletico Madrid kulüplerinde forma giydi. Gabriel Paulista, 2024-25 sezonu başında Beşiktaşımızla sözleşme imzaladı.",
  },
  {
    name: "Emirhan Topçu",
    position: "Defans",
    jersey_number: 53,
    img: "https://images.bjk.com.tr/images/players/emirhan-topcu_229x270.png",
    statistics:
      "11 Ekim 2000 tarihinde dünyaya geldi. 188 cm boyundaki defans oyuncusu; Celik Zenica, Menemen FK ve Çaykur Rizespor kulüplerinde forma giydi. Emirhan Topçu, 2024-25 sezonu başında Kulübümüzle sözleşme imzaladı.",
  },
  {
    name: "Felix Uduokhai",
    position: "Defans",
    jersey_number: 14,
    img: "https://images.bjk.com.tr/images/players/felix-uduokhai_229x270_000001.png",
    statistics:
      "9 Eylül 1997 tarihinde Almanya’da dünyaya geldi. 193 cm boyundaki defans oyuncusu; 1860 Münih, Wolfsburg ve Augsburg kulüplerinde forma giydi. Felix Uduokhai, 2024-25 sezonu başında Kulübümüzle sözleşme imzaladı.",
  },
  {
    name: "Necip Uysal",
    position: "Defans",
    jersey_number: 20,
    img: "https://images.bjk.com.tr/images/players/necip-uysal_229x270_000008.png",
    statistics:
      "24 Ocak 1991 tarihinde dünyaya geldi. 2004 yılında Yıldırım Bosna Spor’dan Özkaynak Düzenimize transfer olan 180 cm boyundaki orta saha oyuncusu Necip Uysal, 2008-09 sezonunda A Takım kadromuza yükseldi.",
  },
  {
    name: "Salih Uçan",
    position: "Orta Saha",
    jersey_number: 8,
    img: "https://images.bjk.com.tr/images/players/salih-ucan_229x270_000002.png",
    statistics:
      "6 Ocak 1994 tarihinde Muğla Marmaris’te dünyaya geldi. 182 cm boyundaki orta saha oyuncusu Uçan; Bucaspor, Roma, Fenerbahçe, Sion, Empoli ve Alanyaspor kulüplerinde forma giydi. Salih Uçan, 2021-22 sezonu başında Beşiktaşımız ile sözleşme imzaladı.",
  },
  {
    name: "Gedson Fernandes",
    position: "Orta Saha",
    jersey_number: 83,
    img: "https://images.bjk.com.tr/images/players/gedson-carvalho-fernandes_229x270_000002.png",
    statistics:
      "9 Ocak 1999 tarihinde dünyaya geldi. 183 cm boyundaki orta saha oyuncusu; Benfica, Tottenham, Galatasaray ve Çaykur Rizespor kulüplerinde forma giydi. Gedson Fernandes, 2022-23 sezonu başında Beşiktaşımızla sözleşme imzaladı.",
  },
  {
    name: "Milot Rashica",
    position: "Orta Saha",
    jersey_number: 7,
    img: "https://images.bjk.com.tr/images/players/milot-rashica_229x270_000001.png",
    statistics:
      "28 Haziran 1996 tarihinde dünyaya geldi. 178 cm boyundaki orta saha oyuncusu; Vitesse, Werder Bremen, Norwich City ve Galatasaray kulüplerinde forma giydi. Milot Rashica, 2023-24 sezonu yaz transfer döneminde Kulübümüzle sözleşme imzaladı.",
  },
  {
    name: "Ernest Muçi",
    position: "Orta Saha",
    jersey_number: 23,
    img: "https://images.bjk.com.tr/images/players/ernest-muci_229x270.png",
    statistics:
      "19 Mart 2001 tarihinde Arnavutluk’ta dünyaya geldi. 180 cm boyundaki orta saha oyuncusu KF Tirana ve Legia Varşova kulüplerinde fora giydi. Ernest Muçi, 2023-24 sezonu devre arası transfer döneminde Kulübümüzle sözleşme imzaladı.",
  },
  {
    name: "Al-Musrati",
    position: "Orta Saha",
    jersey_number: 28,
    img: "https://images.bjk.com.tr/images/players/almoatasembellah-ali-mohamed-al-musrati_229x270.png",
    statistics:
      "6 Nisan 1996 tarihinde dünyaya geldi. 189 cm boyundaki orta saha oyuncusu; Rio Ave, Vitoria Guimaraes ve Sporting Braga kulüplerinde forma giydi. Al-Musrati, 2023-24 sezonu devre arasında Kulübümüzle sözleşme imzaladı.",
  },
  {
    name: "Rafa Silva",
    position: "Orta Saha",
    jersey_number: 27,
    img: "https://images.bjk.com.tr/images/players/rafael-silva_229x270.png",
    statistics:
      "17 Mayıs 1993 tarihinde Portekiz’de dünyaya geldi. 172 cm boyundaki orta saha oyuncusu Braga ve Benfica kulüplerinde forma giydi. Rafael Silva, 2024-25 sezonu öncesinde Beşiktaşımızla sözleşme imzaladı.",
  },
  {
    name: "Cher Ndour",
    position: "Orta Saha",
    jersey_number: 73,
    img: "https://images.bjk.com.tr/images/players/cher-ndour_229x270.jpg",
    statistics:
      "27 Temmuz 2004 tarihinde İtalya’da dünyaya geldi. 190 cm boyundaki orta saha oyuncusu; Benfica, PSG ve Braga kulüplerinde forma giydi. Cher Ndour, 2024-25 sezonu başında Kulübümüzle sözleşme imzaladı.",
  },
  {
    name: "Semih Kılıçsoy",
    position: "Forvet",
    jersey_number: 9,
    img: "https://images.bjk.com.tr/images/players/semih-kilicsoy-2-2_229x270_000001.png",
    statistics:
      "15 Ağustos 2005 tarihinde dünyaya geldi. Altyapımızda yetişen 178 cm boyundaki hücum oyuncusu Semih Kılıçsoy, 2022-23 sezonunda A Takımımıza yükseldi.",
  },
  {
    name: "Mustafa Erhan Hekimoğlu",
    position: "Forvet",
    jersey_number: 91,
    img: "https://images.bjk.com.tr/images/players/mustafa-erhan-hekimoglu-2_229x270.png",
    statistics:
      "22 Nisan 2007 tarihinde dünyaya geldi. Altyapımızda yetişen hücum oyuncusu Mustafa Erhan Hekimoğlu, 2023-24 sezonunda A Takımımıza yükseldi.",
  },
  {
    name: "Ciro Immobile",
    position: "Forvet",
    jersey_number: 17,
    img: "https://images.bjk.com.tr/images/players/ciro-immobile_229x270.png",
    statistics:
      "20 Şubat 1990 tarihinde İtalya’da dünyaya geldi. 185 cm boyundaki hücüm oyuncusu; Juventus, Genoa, B. Dortmund, Sevilla, Torino ve Lazio kulüplerinde forma giydi. Ciro Immobile, 2024-25 sezonu öncesinde Kulübümüzle sözleşme imzaladı.",
  },
];
